exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__FieldSubText__root {\n  display: flex;\n  overflow: hidden;\n}\n\n.DS__FieldSubText__inner {\n  display: flex;\n  width: 100%;\n  padding: 14px 16px 16px;\n  margin-top: 6px;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222a37;\n  background-color: #f4f9e6;\n  border-radius: 8px;\n}\n\n.DS__FieldSubText__invalid {\n  padding: 16px;\n  background-color: #feedee;\n}\n\n.DS__FieldSubText__text {\n  padding: 0;\n  margin: 0;\n}\n\n.DS__FieldSubText__icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  margin-right: 11px;\n  color: #f14d56;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__FieldSubText__root",
	"inner": "DS__FieldSubText__inner",
	"invalid": "DS__FieldSubText__invalid",
	"text": "DS__FieldSubText__text",
	"icon": "DS__FieldSubText__icon"
};